import React, { useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/material';
import theme from 'styles/motoTheme';
import { useThemeContext } from 'contexts/ThemeContext';

const AppLayout = ({ children }) => {
  const { mainColor, textColor } = useThemeContext();
  return <ThemeProvider theme={theme({ mainColor, textColor })}>{children}</ThemeProvider>;
};

export default AppLayout;
